import { render, staticRenderFns } from "./PaymentTemplate.vue?vue&type=template&id=38946550&scoped=true"
import script from "./PaymentTemplate.vue?vue&type=script&lang=ts"
export * from "./PaymentTemplate.vue?vue&type=script&lang=ts"
import style0 from "./PaymentTemplate.vue?vue&type=style&index=0&id=38946550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38946550",
  null
  
)

export default component.exports